import { createContext } from "react";

export const ContextoUsuario = createContext();
ContextoUsuario.displayName = "ContextoUsuario";
